import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { apiUrls } from '../../../config/api/api-urls.config';
import { TournamentsResultsResponse } from '../../../models/tournaments/responses/api-tournaments-results-response.model';
import { TournamentUsersResultsResponse } from '../../../models/tournaments/responses/api-tournament-users-results-response.model';
import { TournamentsFiltersRequest } from '../../../models/tournaments/requests/api-tournaments-get-request.model';
import { TournamentReward } from '../../../models/tournaments/tournament-reward.model';

@Injectable({
  providedIn: 'root'
})
export class ApiTournamentsService {

  constructor(private apiService: ApiService) { }

  getTournaments(page: number, resultCount: number, filters: TournamentsFiltersRequest): Promise<TournamentsResultsResponse> {
    return new Promise<TournamentsResultsResponse>((resolve, reject) => {
      const body = { page, result_count: resultCount, filters };
      this.apiService.launchAdminApiRequestPost(apiUrls.tournamentsGetTournamentsUrl, body, TournamentsResultsResponse).then(
        (data: TournamentsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  getTournamentUsers(page: number, resultCount: number, tournamentId: number): Promise<TournamentUsersResultsResponse> {
    return new Promise<TournamentUsersResultsResponse>((resolve, reject) => {
      const body = { page, result_count: resultCount, tournament_id: tournamentId };
      this.apiService.launchAdminApiRequestPost(apiUrls.tournamentsGetTournamentUsersUrl, body, TournamentUsersResultsResponse).then(
        (data: TournamentUsersResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  addTournament(type: number, startDateTimestamp: number, endDateTimestamp: number, costQuantity: number, rewardTotalQuantity: number, rewards: TournamentReward[]): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = {
        type,
        start_date_timestamp: startDateTimestamp,
        end_date_timestamp: endDateTimestamp,
        cost_quantity: costQuantity,
        reward_total_quantity: rewardTotalQuantity,
        rewards: rewards.map(r => ({ range_min: r.rangeMin, range_max: r.rangeMax, reward_quantity: r.rewardQuantity }))
      };
      this.apiService.launchAdminApiRequestPost(apiUrls.tournamentsAddTournamentUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editTournament(tournamentId: number, type: number, startDateTimestamp: number, endDateTimestamp: number, costQuantity: number, rewardTotalQuantity: number, rewards: TournamentReward[]): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = {
        tournament_id: tournamentId,
        type,
        start_date_timestamp: startDateTimestamp,
        end_date_timestamp: endDateTimestamp,
        cost_quantity: costQuantity,
        reward_total_quantity: rewardTotalQuantity,
        rewards: rewards.map(r => ({ range_min: r.rangeMin, range_max: r.rangeMax, reward_quantity: r.rewardQuantity }))
      };
      this.apiService.launchAdminApiRequestPost(apiUrls.tournamentsEditTournamentUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  addTournamentsFromFile(file: File): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.launchAdminApiRequestPostFile(apiUrls.tournamentsAddTournamentsFromFileUrl, formData);
  }

  deleteTournament(tournamentId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.tournamentsDeleteTournamentUrl, { tournament_id: tournamentId }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }
}
